// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3v-gV","inputDescription":"styles_inputDescription__3BCVm"};